import { Color, Spacing } from '@persona-id/design-tokens';
import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
`;

const Wrapper = styled('div')<LoadingIndicatorProps>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 1s;

  ${({ delayed }) =>
    delayed &&
    css`
      animation-delay: 0.5s;
    `}

  padding: ${Spacing[5]} 0;

  ${(p) =>
    p.fullscreen &&
    css`
      height: 100vh;
    `}
`;

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const CheckmarkLoading = styled('svg')`
  border-radius: 50%;
  display: block;
  animation: ${rotate} linear 0.9s;
  animation-iteration-count: infinite;
`;

const CircleLoading = styled('circle')`
  stroke-dasharray: 166;
  stroke-dashoffset: 110;
  stroke-linecap: round;
  stroke: ${Color.CorePurple500};
`;

interface LoadingIndicatorProps {
  className?: string;
  fullscreen?: boolean;
  delayed?: boolean;
}

/**
 * Dashboard loading spinner.
 */
const LoadingIndicator = ({ className, fullscreen, delayed = true }: LoadingIndicatorProps) => (
  <Wrapper className={className} fullscreen={fullscreen} delayed={delayed} aria-label='Loading...'>
    <CheckmarkLoading viewBox='0 0 52 52' width={120} height={120}>
      <title>loading spinner</title>
      <CircleLoading cx='26' cy='26' r='25' fill='none' />
    </CheckmarkLoading>
  </Wrapper>
);

export default LoadingIndicator;
